import * as React from 'react';
import WebFlowObject from '../../model/WebFlowObject';
import VideoFlowObject from '../../model/VideoFlowObject';
import ImageAsset from '../../model/Assets';
import html2canvas from 'html2canvas';
import _debounce from 'lodash.debounce';
import { MachineContext } from '../fsm/useMachine';
import { FlowObjects, SET_CURRENT_OBJECT, ADD_MMO, MARK_ACTIVE, MARK_INACTIVE } from '../fsm/types';
import { isProd, string_id } from '../utils/getInfo';
import { useSnackbar } from 'notistack';
import _cloneDeep from "lodash.clonedeep"
import { dataURLtoFile } from '../utils/commonFunctions';

export const AddUrl: React.FC<{ isYoutube: boolean, close: () => void }> = ({ isYoutube, close }) => {
    const [src, setSrc] = React.useState("")
    const [url, setUrl] = React.useState("")
    const [current, send] = React.useContext(MachineContext)
    const [imgsrc, setImgSrc] = React.useState("")
    const imgRef = React.useRef<(HTMLImageElement | null)>(null)
    const { enqueueSnackbar } = useSnackbar();

    const changeUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
        send({ type: MARK_ACTIVE, id: "webUrl" })
        e.preventDefault()
        e.stopPropagation()
        let cuRRL = e.currentTarget.value
        if (!cuRRL.startsWith("https://")) {
            setUrl(`https://${cuRRL}`)
        } else {
            setUrl(cuRRL)
        }
        send({ type: MARK_INACTIVE })
    }

    const onChange = () => {
        if (isYoutube) {
            // Example
            let youtube_video_id = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)?.pop();

            if (youtube_video_id?.length == 11) {
                // NOTE: this will not work on local (flowvella.local)
                // Requires an HTTPS context
                let video_thumbnail = `/include/proxy/get-proxy.php?url=https://img.youtube.com/vi/${youtube_video_id!}/hqdefault.jpg`;
                if (!isProd()) {
                    enqueueSnackbar("Webview only works in HTTPS contexts.")
                } else {
                    setImgSrc(video_thumbnail)
                    setSrc(url)
                }
            }
        } else {
            // NOTE: this will not work on local (flowvella.local)
            // Requires an HTTPS context
            if (!isProd()) {
                enqueueSnackbar("Webview only works in HTTPS contexts.")
            } else {
                setImgSrc(`/include/proxy/get-proxy.php?url=${url}`)
                setSrc(url)
            }
        }
    }

    const delayedQuery = React.useCallback(_debounce(onChange, 500), [onChange]);

    React.useEffect(() => {
        delayedQuery();

        // Cancel the debounce on useEffect cleanup.
        return delayedQuery.cancel;
    }, [onChange, delayedQuery]);

    const onSubmit = async () => {
        if (isYoutube) {
            console.info(imgRef.current)
            enqueueSnackbar(`Your video will be added when processing is complete`)

            html2canvas(imgRef.current!, { allowTaint: true, }).then(async (canvas: HTMLCanvasElement) => {
                let preview = canvas.toDataURL("image/png")
                let toAdd: FlowObjects;
                let youtube_video_id = src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)?.pop();
                let srcUrl = `https://www.youtube.com/embed/${youtube_video_id}?autoplay=0`
                toAdd = VideoFlowObject.default({ vidSrc: {__tag: "string", value:srcUrl}, name: `${youtube_video_id}.png`, width: 480, height: 360, isYoutube: "YES" })
                let draftObject = _cloneDeep(toAdd)
                draftObject.originalImageAsset = ImageAsset.default({__tag: "file", value: dataURLtoFile(preview, `${youtube_video_id}.png`)})
                draftObject.croppedImageAsset = ImageAsset.default({__tag: "file", value: dataURLtoFile(preview, `${youtube_video_id}.png`)})
                toAdd.__forceUseImage = true
                toAdd.originalImageAsset = ImageAsset.default({__tag: "string", value: preview})
                toAdd.croppedImageAsset = ImageAsset.default({__tag: "string", value: preview})

                send([{ type: ADD_MMO, mmo: toAdd, draft: draftObject, screenIndex: current.context.index }, { type: SET_CURRENT_OBJECT, id: toAdd.id }])

            })
            close()

        } else {
            enqueueSnackbar(`Your webview will be added when processing is complete`)

            fetch(`/flow/${string_id}/htmltoimage?url=${src}`).then(r => r.blob()).then(async r => {
                var reader = new FileReader();
                reader.readAsDataURL(r);
                reader.onloadend = async function () {
                    let preview = reader.result as string;
                    let toAdd = WebFlowObject.default(src, 545, 600)
                    let draftObject = _cloneDeep(toAdd)
                    draftObject.originalImageAsset = ImageAsset.default({ __tag: "file", value: dataURLtoFile(preview as string, `${src}.png`)})
                    draftObject.croppedImageAsset = ImageAsset.default({ __tag: "file", value: dataURLtoFile(preview as string, `${src}.png`)})
                    toAdd.__forceUseImage = true
                    toAdd.originalImageAsset = ImageAsset.default({__tag: "string", value: preview as string})
                    toAdd.croppedImageAsset = ImageAsset.default({__tag: "string", value: preview as string})
                    send([{ type: ADD_MMO, mmo: toAdd, draft: draftObject, screenIndex: current.context.index }, { type: SET_CURRENT_OBJECT, id: toAdd.id }])
                }
            })
            close()

        }

    }

    return (
        <div className="youtube-wrapper">
            <h4>Add {isYoutube ? "YouTube" : "Webview"}</h4>
            <input placeholder={`Enter URL like ${isYoutube ? "youtube.com" : "example.com"}`} className="addurl-input" type="url" onChange={changeUrl} onFocus={() => send({ type: MARK_ACTIVE })} />
            {isYoutube && imgsrc.length > 0 ? (<img src={imgsrc} ref={imgRef} className="addurl-preview" />) : (<iframe src={imgsrc} className="addurl-preview" />)}
            <br />
            <button onClick={onSubmit} className="addurl-button">Add to Flow</button>
        </div >
    )
}

AddUrl.displayName = "Add URL Modal"